import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

/** @deprecated Please use components/lib/icons/icon.jsx instead */
export default function BaseIcon(props) {
  let { className, viewBox, ...otherProps } = props;
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      viewBox={viewBox || '0 0 19 21'}
      className={classnames('iconContainer', className)}
      {...otherProps}
    />
  );
}

BaseIcon.propTypes = {
  className: PropTypes.string,
  viewBox: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/icon_container.jsx